// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"132":"5e0bb341","248":"3069c1fb","258":"c709d094","312":"ff9e1eaa","439":"68726ab9","443":"43ac8a5d","521":"9e898843","573":"68e6ea88","704":"5cdd221f","732":"0a2a1411","963":"931c5003"}[chunkId] + ".chunk.js";
};